// history/constants.ts
export const HISTORY_LIMIT = 100;
export const BATCH_DELAY = 400;

